import { ConfirmSateType } from '../../../types/confirm.types';

export const getConfirmSelector = (state: {
  ui: { confirm: ConfirmSateType };
}) => state.ui.confirm;
